import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
  GET_DOCUMENT_LIST: {
    url: "document-list",
    method: "get",
  },
  DOWNLOAD_DOCUMENT: {
    url: "download-document",
    method: "post",
  },
};

export const useDocumentList = () =>
  useApiFetcherSWR(API_ENDPOINT.GET_DOCUMENT_LIST);

export const useDownloadDocument = () =>
  useApiFetcherSWR(API_ENDPOINT.DOWNLOAD_DOCUMENT);